import { IRequestTicket } from "../../../types/ticket.interface";
import customAxios from "../../customAxios";
import { FIND_TICKET } from "../../routes";
// import {ADMIN_ALL_SERVICE} from "../../routes";

const findTicket = async (props: IRequestTicket) => {
  var thisUrl = FIND_TICKET + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_Ticket: error });
  }
};

export default findTicket;
